import actions from "./actions";

const reducers = {
  [actions.exportMessages.request]: (state) => {
    state.loading = true;
  },
  [actions.exportMessages.success]: (state) => {
    state.loading = false;
  },
  [actions.exportMessages.failure]: (state) => {
    state.loading = false;
  },
};

export default reducers;
